import { render, staticRenderFns } from "./PoliticasDePrivacidad.vue?vue&type=template&id=690554ab"
import script from "./PoliticasDePrivacidad.vue?vue&type=script&lang=ts"
export * from "./PoliticasDePrivacidad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports